import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { RemsoftSpeciesGroupService } from '../proxy/general/controllers/remsoft-species-group.service';
import { SpeciesGroupService } from '../proxy/general/controllers/species-group.service';
import { GenusService } from '@planning/proxy/planning/controllers/genus.service';

FieldBuilder.setNamespace('General');

export const SPECIES_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Species.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .foreignKey('remsoftSpeciesGroupId', 'Entity.Species.RemsoftSpeciesGroup', RemsoftSpeciesGroupService)
    .displayFromNested('remsoftSpeciesGroup.name')
    .sortBy('remsoftSpeciesGroup.name')
    .build(),
  FieldBuilder
    .foreignKey('logisticsSpeciesGroupId', 'Entity.Species.LogisticsSpeciesGroup', RemsoftSpeciesGroupService)
    .required()
    .displayFromNested('logisticsSpeciesGroup.name')
    .sortBy('logisticsSpeciesGroup.name')
    .build(),
  FieldBuilder
    .foreignKey('speciesGroupId', 'Entity.SpeciesGroup', SpeciesGroupService)
    .required()
    .displayFromNested('speciesGroup.name')
    .sortBy('speciesGroup.name')
    .build(),
  FieldBuilder
    .foreignKey('genusId', 'Entity.Species.Genus', GenusService)
    .required()
    .display('name')
    .keyField('id')
    .build(),
];

export const SPECIES_CONFIG = {
  entityName: 'Species',
  localizationKey: 'General::Entity.Species',
  fields: SPECIES_FIELDS,
  permission: 'ResearchAndDevelopmentGeneticMaterial.Specieses',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.ResearchAndDevelopment + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.GeneticMaterial + MENU_NAME_SUFFIX,
};
